module.exports = __webpack_public_path__ + "img/ereszkalkulator_24_konyoktipusa_jobb_konyok_szurke.fcd8b747.png";